<template>
  <svg
    version="1.1"
    :id="iconName"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 12 12"
    fill="none"
    style="enable-background:new 0 0 12 12;"
    :class="iconName"
    xml:space="preserve"
    :width="width"
    :height="height"
  >
    <title :id="iconName" lang="en">{{ iconName }} icon</title>
    <path
      id="icon_info"
      d="M6 0C2.68548 0 0 2.70968 0 6C0 9.31452 2.68548 12 6 12C9.29032 12 12 9.31452 12 6C12 2.70968 9.29032 0 6 0ZM6 2.66129C6.55645 2.66129 7.01613 3.12097 7.01613 3.67742C7.01613 4.25806 6.55645 4.69355 6 4.69355C5.41935 4.69355 4.98387 4.25806 4.98387 3.67742C4.98387 3.12097 5.41935 2.66129 6 2.66129ZM7.35484 8.80645C7.35484 8.97581 7.20968 9.09677 7.06452 9.09677H4.93548C4.76613 9.09677 4.64516 8.97581 4.64516 8.80645V8.22581C4.64516 8.08065 4.76613 7.93548 4.93548 7.93548H5.22581V6.3871H4.93548C4.76613 6.3871 4.64516 6.26613 4.64516 6.09677V5.51613C4.64516 5.37097 4.76613 5.22581 4.93548 5.22581H6.48387C6.62903 5.22581 6.77419 5.37097 6.77419 5.51613V7.93548H7.06452C7.20968 7.93548 7.35484 8.08065 7.35484 8.22581V8.80645Z"
      fill="#F83030"
    />
  </svg>
</template>
<style scoped>
.icon-info {
  border-radius: initial;
  display: block;
}
</style>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "icon-info"
    },
    width: {
      type: [Number, String],
      default: 12
    },
    height: {
      type: [Number, String],
      default: 12
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>